export default __webpack_public_path__ + "static/UniversalTemplate-939cdf315a03d9af4ab55dac771866b0.png";